module.exports = __webpack_public_path__ + "img/travelService-ganbo-video.85b6080e.png";